import * as React from "react";
import { useFormContext } from "react-hook-form";
import { DropdownInput } from "../../../runQuote/components/DropdownInput";
import { SwitchInput } from "../../../runQuote/components/SwitchInput";

const LIABILITY_LIMITS = [
  { value: "100k", label: "100k" },
  { value: "300k", label: "300k" },
  { value: "500k", label: "500k" },
];

const MED_PAY = [
  { value: "1k", label: "1k" },
  { value: "2.5k", label: "2.5k" },
  { value: "5k", label: "5k" },
];

const DEDUCTIBLE = [
  { value: "250", label: "250" },
  { value: "500", label: "500" },
  { value: "1k", label: "1k" },
];

const THEFT_SUBLIMIT = [
  { value: "None", label: "None" },
  { value: "2k", label: "2k" },
  { value: "3k", label: "3k" },
  { value: "4k", label: "4k" },
  { value: "5k", label: "5k" },
];

const HOME_COMPUTER = [
  { value: "None", label: "None" },
  { value: "3k", label: "3k" },
  { value: "4k", label: "4k" },
  { value: "5k", label: "5k" },
  { value: "6k", label: "6k" },
  { value: "7k", label: "7k" },
  { value: "8k", label: "8k" },
  { value: "9k", label: "9k" },
  { value: "10k", label: "10k" },
];

const PAYMENT_PLAN = [
  { value: "Pay In Full", label: "Pay In Full" },
  { value: "Monthly EFT", label: "Monthly EFT" },
];

export function RentersCoverages() {
  const { control } = useFormContext();

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold">Coverages</h2>

      <DropdownInput
        control={control}
        label="Liability Limit"
        dropdownLabel="Select"
        stepName="step4.liabilityLimit"
        stepId="step4"
        itemList={LIABILITY_LIMITS}
      />

      <DropdownInput
        control={control}
        label="Medical Payments Limit"
        dropdownLabel="Select"
        stepName="step4.medicalPaymentsLimit"
        stepId="step4"
        itemList={MED_PAY}
      />

      <DropdownInput
        control={control}
        label="Deductible"
        dropdownLabel="Select"
        stepName="step4.deductible"
        stepId="step4"
        itemList={DEDUCTIBLE}
      />

      <DropdownInput
        control={control}
        label="Increased Sublimit for Theft of Jewelry, Watches and Furs"
        dropdownLabel="Select"
        stepName="step4.theftSublimit"
        stepId="step4"
        itemList={THEFT_SUBLIMIT}
      />

      <DropdownInput
        control={control}
        label="Home Computer Coverage"
        dropdownLabel="Select"
        stepName="step4.homeComputerCoverage"
        stepId="step4"
        itemList={HOME_COMPUTER}
      />

      <DropdownInput
        control={control}
        label="Payment Plan"
        dropdownLabel="Select"
        stepName="step4.paymentPlan"
        stepId="step4"
        itemList={PAYMENT_PLAN}
      />
      <p className="text-xs text-gray-500">
        Pay by mail, cash, or card is not offered.
      </p>

      <SwitchInput
        control={control}
        id="rentersRunClue"
        stepName="step4.runClue"
        stepId="step4"
        label="Would you like Cover Badger to Run Clue for this insured prior to returning a quote?"
      />
      <p className="text-xs text-gray-500">
        All agencies are required to pay for all Clue reports which will be applied to their commission statement.
      </p>

    </div>
  );
}
